<template>
    <CRow>
        <CCol col="12" xl="8">
            <CCard>
                <CCardHeader>
                    <strong>Настройка телеграм чатов</strong>
                </CCardHeader>
                <CCardBody>
                    <TelegramTabLinks />
                    <CRow class="ml-1 mb-3 mr-1 mt-2">
                        <p>
                            Можно указывать несколько chatId телеграм группы через запятую.
                            Чтобы получить chatId группы надо добавить этого бота @chatid_echo_bot в группу
                        </p>
                    </CRow>

                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Чат id телеграм групп для модераций
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="moderationChatIds" placeholder="example: -111111111,  -1212121212" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Чат id телеграм групп для всех заказов</CCol>
                            <CCol sm="9">
                                <CInput v-model="orderChatIds" placeholder="example: -111111111,  -1212121212" />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { cilTrash } from '@coreui/icons';
    import TelegramTabLinks from '@/components/TelegramTabLinks';

    export default {
        name: 'TelegramSettings',
        components: { TelegramTabLinks },
        icons: {
            cilTrash,
        },

        data() {
            return {
                key: 'telegram',
                items: [],
                moderationChatIds: '',
                orderChatIds: ''
            };
        },

        mounted() {
            this.loadSettings()
        },

        methods: {
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            moderationChatIds: this.moderationChatIds
                                .trim()
                                .split(',')
                                .map(i => i.trim())
                                .join(','),
                            orderChatIds: this.orderChatIds
                                .trim()
                                .split(',')
                                .map(i => i.trim())
                                .join(','),
                        }
                    })
                    .then(resp => {
                        this.moderationChatIds = resp.data.value.moderationChatIds
                        this.orderChatIds = resp.data.value.orderChatIds
                        this.$root.$emit('showAlert', 'Успешно.')
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            loadSettings() {
                Vue.axios
                    .get('/settings/' + this.key)
                    .then(resp => {
                        if(resp.data.value) {
                            this.moderationChatIds = resp.data.value.moderationChatIds
                            this.orderChatIds = resp.data.value.orderChatIds
                        }
                    })
            }
        },
    };
</script>